import { pubsub } from '@services';

class SearchInput extends HTMLElement {
  connectedCallback() {
    // Get elements
    this.searchInput = this.querySelector('input[type="search"]');

    // Handle search input
    this.searchInput.addEventListener('input', () => {
      this.publishEvent('search:input');
      this.toggleClearButton();
    });

    // Handle search clear
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-search-clear]')) {
        this.clearSearchInput();
      }
    });
  }

  /**
   * Clear the search input
   */
  clearSearchInput() {
    this.searchInput.value = '';
    this.publishEvent('search:clear');
    this.toggleClearButton();
    this.searchInput.focus();
  }

  /**
   * Publish the event
   */
  publishEvent(eventName) {
    pubsub.publish(`${eventName}:${this.id}`, {
      target: this.id,
      value: this.searchInput.value,
    });
  }

  /**
   * Toggle the clear button
   */
  toggleClearButton() {
    this.querySelector('[data-search-clear]').ariaHidden = this.searchInput.value.length === 0;
  }
}

customElements.define('search-input', SearchInput);
